import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function CloudEditionBanner() {
  const { t } = useTranslation();

  return (
    <div className="mb-12">
      <div className="relative rounded-xl border border-blue-500/30 bg-gradient-to-br from-blue-500/[0.08] via-cyan-500/[0.05] to-purple-500/[0.08] p-8 md:p-10 overflow-hidden">
        {/* Subtle glow accent */}
        <div
          className="pointer-events-none absolute -top-20 -right-20 w-60 h-60 opacity-20"
          style={{
            background:
              "radial-gradient(circle, #3B82F6 0%, #06B6D4 40%, transparent 70%)",
          }}
        />

        <div className="relative flex flex-col md:flex-row md:items-start gap-6">
          {/* Icon */}
          <div className="flex-shrink-0 p-3 rounded-xl bg-blue-500/10 border border-blue-500/20">
            <svg
              className="w-8 h-8 text-blue-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"
              />
            </svg>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-2">
              <h2 className="text-2xl font-bold text-warm-50">{t('downloads.cloudEdition.title')}</h2>
              <span className="text-xs font-medium text-blue-300 bg-blue-500/15 border border-blue-500/25 px-2.5 py-0.5 rounded-full">
                {t('downloads.cloudEdition.badge')}
              </span>
            </div>
            <p className="text-warm-400 mb-5 max-w-2xl">
              {t('downloads.cloudEdition.description')}
            </p>

            <ul className="space-y-2.5 mb-6">
              <li className="flex items-start gap-2.5 text-sm text-warm-300">
                <svg
                  className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t('downloads.cloudEdition.features.dashboard')}
              </li>
              <li className="flex items-start gap-2.5 text-sm text-warm-300">
                <svg
                  className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t('downloads.cloudEdition.features.oneClick')}
              </li>
              <li className="flex items-start gap-2.5 text-sm text-warm-300">
                <svg
                  className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {t('downloads.cloudEdition.features.noInstall')}
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Link
                to="/dashboard"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-2.5 rounded-lg transition-colors"
              >
                {t('downloads.cloudEdition.cta')}
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
              <p className="text-xs text-warm-500">
                {t('downloads.cloudEdition.accessNote')}{" "}
                <a
                  href="mailto:contact@somebugs.com"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  {t('downloads.cloudEdition.contactUs')}
                </a>{" "}
                {t('downloads.cloudEdition.accessSuffix')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
